var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie',{staticStyle:{"margin":"0px"},attrs:{"options":_vm.defaultOptions,"width":350,"height":350}})}
var staticRenderFns = []

export { render, staticRenderFns }